import React, { Component } from 'react';
import { Table } from 'react-bootstrap';

class CommissionsHK extends Component {
    render() {
        return (
            <div className="a-flyRightIn">
                <h3 className="title">HK Stocks</h3>
                <div className="pricing-table-wrap">
                    <Table className="pricing-table">
                        <tbody>
                            <tr>
                                <th></th>
                                <th>Commission / Fees</th>
                                <th>Minimum</th>
                                <th>Maximum</th>
                                <th>Charged By</th>
                            </tr>
                            <tr>
                                <th>SEHK Stocks Commission</th>
                                <td>0.12% of trade value</td>
                                <td>HKD 18 / order</td>
                                <td>N/A</td>
                                <td>TradeUP Securities, Inc.</td>
                            </tr>
                            <tr>
                                <th>Exchange Fee</th>
                                <td>0.00565% trade value</td>
                                <td></td>
                                <td></td>
                                <td>Hong Kong Stock Exchange</td>
                            </tr>
                            <tr>
                                <th>Clearing Fee</th>
                                <td>0.002% trade value</td>
                                <td>HKD 2.00 / execution</td>
                                <td>HKD 100 / execution</td>
                                <td>Clearing Agency</td>
                            </tr>
                            <tr>
                                <th>SFC Transaction Levy</th>
                                <td>0.0027% of transaction value</td>
                                <td></td>
                                <td></td>
                                <td>Hong Kong Stock Exchange</td>
                            </tr>
                            <tr>
                                <th>FRC Transaction Levy</th>
                                <td>0.00015% trade value</td>
                                <td></td>
                                <td></td>
                                <td>Financial Reporting Council</td>
                            </tr>
                            <tr>
                                <th>Stamp Duty</th>
                                <td>
                                    0.13% of transaction value<sup>1</sup>
                                </td>
                                <td></td>
                                <td></td>
                                <td>Hong Kong Government</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
                <p className="notes">
                    Commission to trade Hong Kong stock is 0.08% of trade value during promotion period, valid until
                    7/30/2020.
                </p>
                <p className="sm-title">
                    <strong>Notes</strong>
                </p>
                <p className="notes">
                    1. For stocks traded on the SEHK, government stamp duty will be rounded up to the nearest 1.00.
                    Stamp duty is charged on a per execution basis.
                    <br />
                    • Modified orders will be treated as the cancellation and replacement of an existing order with a
                    new order. On certain exchanges, this may have the effect of subjecting modified orders to
                    commission minimums as if they were new orders. For example, if an order for 200 shares is submitted
                    and 100 shares execute, then you modify the order and another 100 shares execute, a commission
                    minimum would be applied to both 100 share orders. Orders that persist overnight will be considered
                    a new order for the purposes of determining order minimums.
                    <br />• Commissions apply to all order types.
                </p>
            </div>
        );
    }
}

export default CommissionsHK;
